import { render } from "./Focus.vue?vue&type=template&id=0b2ab851"
import script from "./Focus.vue?vue&type=script&lang=js"
export * from "./Focus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__